import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { checkPublishReady, type Farmacia } from "@farmacias/schema";
import { listFarmacias } from "../api";

function StatusBadge({ f }: { f: Farmacia }) {
  if (f.status === "published") {
    return <span className="rounded bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800">Publicada</span>;
  }
  const ready = checkPublishReady(f).ok;
  return (
    <span
      className={`rounded px-2 py-0.5 text-xs font-medium ${
        ready ? "bg-blue-100 text-blue-800" : "bg-slate-100 text-slate-600"
      }`}
    >
      {ready ? "Rascunho (pronta)" : "Rascunho"}
    </span>
  );
}

export function ListPage() {
  const [items, setItems] = useState<Farmacia[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    listFarmacias()
      .then(setItems)
      .catch((e) => setError(e instanceof Error ? e.message : "Erro ao carregar"));
  }, []);

  const filtered = useMemo(() => {
    if (!items) return [];
    const t = q.trim().toLowerCase();
    if (!t) return items;
    return items.filter((f) =>
      [f.nomeFantasia, f.razaoSocial, f.slug, f.endereco.cidade, f.endereco.bairro]
        .join(" ")
        .toLowerCase()
        .includes(t),
    );
  }, [items, q]);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3">
        <h1 className="text-xl font-bold">Farmácias</h1>
        <Link to="/nova" className="btn-primary">
          Nova farmácia
        </Link>
      </div>

      <input
        className="input"
        placeholder="Buscar por nome, slug, cidade…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />

      {error && <p className="rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
      {!items && !error && <p className="text-sm text-slate-500">Carregando…</p>}
      {items && filtered.length === 0 && (
        <p className="text-sm text-slate-500">Nenhuma farmácia encontrada.</p>
      )}

      <ul className="divide-y divide-slate-100 overflow-hidden rounded-xl border border-slate-200 bg-white">
        {filtered.map((f) => (
          <li key={f.slug}>
            <Link to={`/f/${f.slug}`} className="flex items-center justify-between gap-3 px-4 py-3 hover:bg-slate-50">
              <div className="min-w-0">
                <div className="truncate font-medium text-slate-900">
                  {f.nomeFantasia || <span className="text-slate-400">sem nome fantasia</span>}
                </div>
                <div className="truncate text-xs text-slate-500">
                  {f.customDomain && f.customDomainStatus === "active"
                    ? f.customDomain
                    : `${f.slug}.sites.oniochat.com.br`}
                  {f.customDomain && f.customDomainStatus !== "active" && f.customDomainStatus !== "none"
                    ? " · domínio próprio pendente"
                    : ""}
                  {f.endereco.cidade ? ` · ${f.endereco.cidade}/${f.endereco.uf}` : ""}
                </div>
              </div>
              <StatusBadge f={f} />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
